import React, { FC, MouseEvent, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';

import { download } from 'assets/icons';
import { debounce } from 'helpers/debounce';
import { Spinner } from 'components/atoms/spinner';
import { useSelectEvents } from 'hooks/useSelectEvents';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { tepHistoryReportSelector } from 'core/redux/selectors/reports';
import { actions } from 'core/redux/api/reports/actions';

import styles from './styles.module.css';

const OPTIONS = [
  { label: 'XLSX (Excel)', value: 'xlsx' },
  { label: 'CSV', value: 'csv' },
];

export const ExportControl: FC = () => {
  const { history, export: exportState } = useSelector(tepHistoryReportSelector);
  const dispatch = useDispatch();

  const { isMouseOver, showOptions, hideOnMouseOut } = useSelectEvents();

  const wrapperClassname = classNames(styles.wrapper, { [styles.disabled]: !history?.objects?.length });
  const listClassname = classNames(styles.list, { [styles.show]: isMouseOver, [styles.hide]: !isMouseOver });

  const hideOnMouseOutDebounced = useRef(debounce(hideOnMouseOut, 500)).current;

  const onMouseEnter = () => {
    if (history?.objects?.length) {
      hideOnMouseOutDebounced.cancel();
      showOptions();
    }
  };

  const selectFilter = (option: string) => (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    hideOnMouseOut();
    dispatch(actions.tepHistory.export.request({ format: option }));
  };

  return (
    <div className={wrapperClassname} onClick={onMouseEnter} onMouseLeave={hideOnMouseOutDebounced}>
      {exportState?.isLoading ? (
        <span className={styles.spinner}>
          <Spinner />
        </span>
      ) : (
        <SvgWrapper width={25} height={25} details={download} />
      )}
      <div onMouseEnter={onMouseEnter} className={listClassname}>
        {OPTIONS.map(({ label, value }, index) => (
          <div key={index} className={styles.option} onClick={selectFilter(value)}>
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};
